import { GenericFailure, OffsetLimit } from '@playq/services-shared';
import { AppIssueBrief, AppIssueBriefSerialized, IssueSort, IssuesResponse } from '@playq/services-beetle';
import { Environment, Filter, TimePrecision } from '@playq/octopus-common';

import { services2 } from '/api/services2';
import { IUseQueryOptionsExtended } from '/api/service-hooks';
import { QueryHelpers } from '/helpers/query';
import { toMs } from '/helpers/toMs';

import { IBeetleId, IIssueOrRequestSort } from './types';
import { useQueryBase } from './useCustomQuery';
import { issueKeys } from './constants';

export const useQueryIssues = (
  env: Environment = Environment.Live,
  iterator: OffsetLimit = QueryHelpers.getInitIterator(),
  sortBy: IIssueOrRequestSort[] = [],
  filterBy: {
    [key: string]: Filter;
  } = {},
  options?: IUseQueryOptionsExtended<IssuesResponse | undefined, GenericFailure | Error>
) => {
  return useQueryBase<IssuesResponse, AppIssueBrief, IBeetleId, IssueSort, AppIssueBriefSerialized>(
    issueKeys,
    env,
    services2.audienceSupportService.queryIssues.bind(services2.audienceSupportService),
    { iterator, sortBy: sortBy as IssueSort[], filterBy },
    (issue) => issue?.id,
    (response) => response.issues ?? [],
    (response, newEntities) => {
      response.issues = newEntities;
      return newEntities;
    },
    (prevResponse) => new IssuesResponse(prevResponse.serialize()),
    // spread creates new array reference for refetchInterval to rerender current page
    (res) => [...res.serialize().issues],
    (newArray, updatedIterator, updatedTotal) =>
      new IssuesResponse({
        issues: newArray,
        iterator: updatedIterator,
        total: updatedTotal,
      }),
    {
      ...options,
      refetchInterval: toMs(TimePrecision.Minute, 14),
      refetchIntervalInBackground: true,
    }
  );
};
